<template>
	<router-view v-slot="{ Component }">
		<transition :name="route_transition">
			<component :is="Component" />
		</transition>
	</router-view>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core'

export default {
	setup() {
		let route_transition = ref(null)

		onMounted(() => {
			console.log('app load')

			setTimeout(() => {
				route_transition.value = window.matchMedia('(max-width: 991px)').matches ? 'next' : 'fade'
			}, 500)
		})

		return {
			route_transition
		}
	}
}
</script>

<style scoped lang="scss"></style>
